import { createElement } from "rlink-react";

export default function IconRelicLogoFull(props) {
  return (
    <svg id="Layer_1" viewBox="0 0 1286 338" {...props}>
      <path
        fill="#FFFFFF"
        d="M1242.44,2.75H367.37H43.57C21.16,2.75,3,21.25,3,44.06v249.88c0,22.82,18.16,41.32,40.57,41.32h1198.87
	c22.4,0,40.56-18.5,40.56-41.32V44.06C1283,21.25,1264.84,2.75,1242.44,2.75z M315.05,82.07v53.4v4.34l-4.33-0.38
	c-0.72-0.06-72.84-6.22-119.73,16.51c-50.88,25.8-44.55,109.68-44.48,110.52l0.36,4.3h-4.32H79.62h-3.54l-0.41-3.52
	c-0.46-4.1-10.46-99.35,51.85-143.85c0.01-0.01-24.79-41.48-25.43-43c-0.64-1.53-0.89-4.71,2.8-9.68
	c3.69-4.97,10.32-4.78,10.32-4.78h49.81c7.52,0,11.47,5.8,14.97,11.96l6.24,10.51c55.79-17.81,122.43-10.6,125.29-10.28l3.53,0.4
	V82.07z M1274.08,287.03c0,25.25-12.52,39-40,39H371.07V12.17h863.01c26.13,0,40,15.21,40,38.99L1274.08,287.03z"
      />
      <g>
        <g>
          <path
            fill="#FFFFFF"
            d="M429.04,273.89v-31.03h33.28v5.48h-25.66v6.77h14.95v5.34h-14.95v7.63h26.05v5.8h-33.67V273.89z"
          />
          <path
            fill="#FFFFFF"
            d="M491.69,273.89v-31.03h5.2l26.33,20.6v-20.6h6.85v31.03h-5.23l-26.27-20.93v20.93H491.69z"
          />
          <path
            fill="#FFFFFF"
            d="M580.48,248.41v25.48h-7.56v-25.48h-14.98v-5.55h37.55v5.55L580.48,248.41L580.48,248.41z"
          />
          <path
            fill="#FFFFFF"
            d="M623.33,273.89v-31.03h33.28v5.48h-25.66v6.77h14.95v5.34h-14.95v7.63H657v5.8h-33.67V273.89z"
          />
          <path
            fill="#FFFFFF"
            d="M685.99,273.89v-31.03h27.95c2.56,0,4.41,0.47,5.56,1.42c1.15,0.94,1.72,2.48,1.72,4.6v7.31
			c0,2.1-0.57,3.62-1.72,4.55c-1.15,0.93-3,1.4-5.56,1.4h-4.26l14.76,11.75h-10.86l-13-11.75h-7.13v11.75H685.99z M710.71,248.2
			h-17.27v8.6h17.27c1.31,0,2.21-0.19,2.71-0.57c0.49-0.38,0.73-1.03,0.73-1.93v-3.58c0-0.91-0.25-1.55-0.73-1.93
			C712.92,248.39,712.02,248.2,710.71,248.2z"
          />
          <path
            fill="#FFFFFF"
            d="M767.6,248.41v25.48h-7.56v-25.48h-14.98v-5.55h37.54v5.55L767.6,248.41L767.6,248.41z"
          />
          <path
            fill="#FFFFFF"
            d="M800.38,273.89l18.43-31.03h7.27l18.7,31.03h-8.49l-3.91-6.81h-20.54l-3.9,6.81H800.38z M815.07,261.42h14.22
			l-7.24-12.94L815.07,261.42z"
          />
          <path fill="#FFFFFF" d="M870.57,273.89v-31.03h7.53v31.03H870.57z" />
          <path
            fill="#FFFFFF"
            d="M909.97,273.89v-31.03h5.2l26.33,20.6v-20.6h6.85v31.03h-5.23l-26.27-20.93v20.93H909.97z"
          />
          <path
            fill="#FFFFFF"
            d="M980.27,273.89v-31.03h6.06l15.19,18.42l15.12-18.42h6.09v31.03h-7.02v-21.36l-13.86,17.63h-1.47
			l-14.05-17.13v20.85L980.27,273.89L980.27,273.89z"
          />
          <path
            fill="#FFFFFF"
            d="M1054.61,273.89v-31.03h33.29v5.48h-25.66v6.77h14.95v5.34h-14.95v7.63h26.05v5.8h-33.68V273.89z"
          />
          <path
            fill="#FFFFFF"
            d="M1117.28,273.89v-31.03h5.2l26.33,20.6v-20.6h6.85v31.03h-5.23l-26.27-20.93v20.93H1117.28z"
          />
          <path
            fill="#FFFFFF"
            d="M1206.06,248.41v25.48h-7.56v-25.48h-14.98v-5.55h37.55v5.55L1206.06,248.41L1206.06,248.41z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M801.7,175.51c0-32.53-37.67-72-84.15-72c-46.48,0-84.15,39.46-84.15,72c0,0,1.39,30.58,26.74,46.39
			l20.22-19.89c0,0-17.61-13.7-14.6-26.5C666.35,176.08,801.7,175.51,801.7,175.51z M717.55,134.01
			c21.93,0.57,36.77,13.62,37.42,16.55h-74.85C680.78,145.83,700.35,133.52,717.55,134.01z"
          />
          <path
            fill="#FFFFFF"
            d="M885.88,221.93c3.28,0,5.95-2.67,5.95-5.95V57.7c0-3.29-2.67-5.95-5.95-5.95h-21.42
			c-3.3,0-5.96,2.67-5.96,5.95v158.29c0,3.28,2.66,5.95,5.96,5.95L885.88,221.93L885.88,221.93z"
          />
          <path
            fill="#FFFFFF"
            d="M993.85,88.63c3.28,0,5.95-2.66,5.95-5.94v-23.8c0-3.29-2.67-5.95-5.95-5.95h-21.43
			c-3.29,0-5.95,2.66-5.95,5.95v23.8c0,3.28,2.66,5.94,5.95,5.94H993.85z"
          />
          <path
            fill="#FFFFFF"
            d="M995.04,221.93c3.29,0,5.95-2.67,5.95-5.95V111.25c0-3.28-2.66-5.94-5.95-5.94h-21.43
			c-3.28,0-5.94,2.66-5.94,5.94v104.74c0,3.28,2.66,5.95,5.94,5.95L995.04,221.93L995.04,221.93z"
          />
          <path
            fill="#FFFFFF"
            d="M1211.11,193.99h-74.27c-27.03,0.11-32.55-10.03-32.13-25.83v-4.55l0,0v-4.54
			c-0.42-15.81,5.1-25.95,32.13-25.84h74.27c2.63,0,4.75-2.07,4.75-4.67l0.36-17.41c0-3.23-2.66-5.86-5.96-5.86h-95.2
			c-25.01,0.29-41.66,14.65-41.66,38.75v19.56l0,0v19.56c0,24.09,16.65,38.46,41.66,38.75h95.2c3.3,0,5.96-2.63,5.96-5.87
			l-0.36-17.41C1215.87,196.06,1213.74,193.99,1211.11,193.99z"
          />
          <path
            fill="#FFFFFF"
            d="M498.69,111.02l-5.29-8.89c-1.47-3.01-3.26-5.96-6.56-5.96h-32.42c-3.3,0-5.96,2.66-5.96,5.96l17.22,29.01
			c-41.25,27.29-34.04,90.99-34.04,90.99h40.26c0,0-4.65-55.69,29.84-73.18c31.04-15.05,77.97-10.83,77.97-10.83v-34.16
			C579.72,103.95,534.63,98.85,498.69,111.02z"
          />
          <g>
            <g>
              <polygon
                fill="#FFFFFF"
                points="1233.33,88.61 1235.76,88.61 1235.76,80.34 1241.32,87.14 1241.91,87.14 1247.41,80.13 
					1247.41,88.61 1250.22,88.61 1250.22,76.28 1247.79,76.28 1241.79,83.6 1235.76,76.28 1233.33,76.28 				"
              />
            </g>
            <g>
              <polygon
                fill="#FFFFFF"
                points="1225.24,78.49 1231.25,78.49 1231.25,76.28 1216.23,76.28 1216.23,78.49 1222.21,78.49 
					1222.21,88.63 1225.24,88.63 				"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/svg/iconRelicLogoFull.jsx